<template>
  <div>
    <div class="row" v-if="selected.length > 0">
      <div class="col-md-3">
        <button v-on:click="shutdown_devices" class="btn btn-danger">Shutdown Devices</button>
      </div>
      <div class="col-md-3">
        <button v-on:click="restart_devices" class="btn btn-danger">Restart Devices</button>
      </div>
    </div>
    <br/>
    <div class="table-responsive">
      <table class="table table-hover">
          <thead>
              <tr>
                  <th v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99">
                    <label class="form-checkbox">
                      <input type="checkbox" v-model="selectAll" @change="select">
                      <i class="form-icon"></i>
                    </label>
                  </th>
                  <th v-for="key in columns"
                      @click="sortBy(key)"
                      :class="{ active: sortKey == key }">
                      {{ key | capitalize }}
                      <span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
                      </span>
                  </th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="entry in filteredData">
                  <td v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99">
                    <label class="form-checkbox">
                      <input type="checkbox" :value="entry['.key']" :disabled="entry.type == 'Location Tag'" v-model="selected">
                      <i class="form-icon"></i>
                    </label>
                  </td>
                  <td>{{entry.name}}</td>
                  <td>{{entry.type}}</td>
                  <td v-if="org['curOrg']['role'] == 99"><button class="btn btn-default" v-on:click="selectDevice(entry.type, entry['.key'])">More</button></td>
              </tr>
          </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import store from '../../../components/webmaster/Store/vuex'

import firebase from 'firebase'

import MDMService from '@/services/MDMService.js'

export default {
  name: 'datatable',
   props: {
    data: Object,
    columns: Array,
    filterKey: String,
    url: String
  },
  data: function () {
    var sortOrders = {}
    this.columns.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      sortKey: '',
      sortOrders: sortOrders,
      org: store.state.usermain,
      selected: [],
      selectAll: false,
    }
  },
  computed: {
    filteredData: function () {
      var sortKey = this.sortKey
      var filterKey = this.filterKey && this.filterKey.toLowerCase()
      var order = this.sortOrders[sortKey] || 1
      var data = Object.values(this.data)
      if (filterKey) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return data
    }
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    sortBy: function (key) {
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
    },
    select() {
			this.selected = [];
			if (this.selectAll) {
				for (let i in this.filteredData) {
          if (this.filteredData[i].type == 'Mobile Device') {
            this.selected.push(this.filteredData[i]['.key']);
          }
				}
			}
		},
    selectDevice: function(type, id){
      type = type.replace(/\s+/g, '');
      type = type.toLowerCase()
      this.$router.push('/admin/device/edit/' + type + "/" + id)
    },
    async shutdown_devices() {
      const devices = this.data;

      const mdmDeviceIds = [];

      this.selected.forEach((deviceId) => {
        if (devices[deviceId].mdm_device_id != null) {
          mdmDeviceIds.push(devices[deviceId].mdm_device_id);
        }
      });

      console.log(mdmDeviceIds)

      if (mdmDeviceIds.length > 0) {
        const idToken = await firebase.auth().currentUser.getIdToken();

        let response = await MDMService.shutdownDevices(mdmDeviceIds, idToken);

        console.log(response);
      }

      this.selected = []
      this.selectAll = false
    },
    async restart_devices() {
      const devices = this.data;

      const mdmDeviceIds = [];

      this.selected.forEach((deviceId) => {
        if (devices[deviceId].mdm_device_id != null) {
          mdmDeviceIds.push(devices[deviceId].mdm_device_id);
        }
      });

      if (mdmDeviceIds.length > 0) {
        const idToken = await firebase.auth().currentUser.getIdToken();

        console.log(mdmDeviceIds)

        await MDMService.restartDevices(mdmDeviceIds, idToken);
      }

      this.selected = []
      this.selectAll = false
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
}
</style>



// WEBPACK FOOTER //
// DevicesTable.vue?35fe834f